import _implicitStylesheets from "./footer.css";
import _implicitScopedStylesheets from "./footer.scoped.css?scoped=true";
import _pageLink from "page/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="cloud-top${0}"${"s0"}${"a0:title"}${2}></div>`;
const $fragment2 = parseFragment`<div class="cloud-bottom${0}"${"s0"}${"a0:title"}${2}></div>`;
const $fragment3 = parseFragment`<img${"a0:src"} class="trees-and-mountain${0}" height="450"${"a0:alt"}${2}>`;
const $fragment4 = parseFragment`<svg viewBox="0 0 1440 248" version="1.1" xmlns="http://www.w3.org/2000/svg"${3}><path d="M1440,-4.54747351e-13 L1440,248 L0,248 L0,167.417679 C608.422516,322.819505 1178.89,231.537415 1440,-4.54747351e-13 Z" fill="#0E2D60"${3}/></svg>`;
const $fragment5 = parseFragment`<div class="slds-size_1-of-6${0}"${2}><img${"a1:src"} width="114" height="80"${"a1:alt"}${3}></div>`;
const $fragment6 = parseFragment`<a target="_blank" href="http://go.appexchange.com/partnerprogram?_ga=2.181943975.1892729412.1643131721-912599546.1620910617"${"a0:title"} data-test-id="offer-your-solution"${3}>${"t1"}</a>`;
const $fragment7 = parseFragment`<a target="_blank" href="https://www.salesforce.com/company/privacy/"${"a0:title"} data-test-id="privacy-statement"${3}>${"t1"}</a>`;
const $fragment8 = parseFragment`<a target="_blank" href="https://www.salesforce.com/company/privacy/security.jsp"${"a0:title"} data-test-id="security-statement"${3}>${"t1"}</a>`;
const $fragment9 = parseFragment`<a target="_blank" href="https://trailblazer.me/terms?lan=en"${"a0:title"} data-test-id="terms-of-use"${3}>${"t1"}</a>`;
const $fragment10 = parseFragment`<a target="_blank" href="https://appexchangejp.salesforce.com/"${"a0:title"} data-test-id="japan-site"${3}>${"t1"}</a>`;
const $fragment11 = parseFragment`<div class="slds-size_1-of-6${0}"${2}></div>`;
const $fragment12 = parseFragment`<a target="_blank" href="https://www.facebook.com/appexchange"${"a0:title"} data-test-id="facebook" class="link${0}"${2}><img${"a1:src"} width="36" height="36"${"a1:alt"} class="facebook${0}"${2}></a>`;
const $fragment13 = parseFragment`<a target="_blank" href="https://www.twitter.com/appexchange"${"a0:title"} data-test-id="twitter"${3}><img${"a1:src"} width="36" height="36"${"a1:alt"} class="twitter${0}"${2}></a>`;
const $fragment14 = parseFragment`<a target="_blank" href="https://www.linkedin.com/showcase/appexchange"${"a0:title"} data-test-id="linked-in"${3}><img${"a1:src"} width="36" height="36"${"a1:alt"} class="linkedin${0}"${2}></a>`;
const $fragment15 = parseFragment`<a target="_blank" href="https://appexchange.salesforce.com/services/xml/NewListings"${"a0:title"} data-test-id="rss-news"${3}><img${"a1:src"} width="36" height="36"${"a1:alt"} class="rss${0}"${2}></a>`;
const $fragment16 = parseFragment`<li class="contact${0}"${2}><span class="call-us${0}"${2}>${"t2"}</span><span data-test-id="phone" class="phone${0}"${2}>${"t4"}</span></li>`;
const $fragment17 = parseFragment`<div class="slds-grid rights${0}"${2}><div class="slds-size_1-of-6${0}"${2}></div><div class="slds-size_5-of-6${0}"${2}><p data-test-id="copyright"${3}>${"t4"}</p></div></div>`;
const stc0 = {
  key: 0
};
const stc1 = {
  classMap: {
    "footer": true
  },
  key: 9
};
const stc2 = {
  classMap: {
    "slds-grid": true
  },
  key: 10
};
const stc3 = {
  classMap: {
    "slds-size_5-of-6": true,
    "links": true
  },
  key: 13
};
const stc4 = {
  key: 14
};
const stc5 = {
  key: 15
};
const stc6 = {
  key: 16
};
const stc7 = {
  key: 19
};
const stc8 = {
  key: 20
};
const stc9 = {
  key: 23
};
const stc10 = {
  key: 24
};
const stc11 = {
  key: 27
};
const stc12 = {
  key: 28
};
const stc13 = {
  key: 31
};
const stc14 = {
  key: 32
};
const stc15 = {
  classMap: {
    "slds-grid": true,
    "social-media": true
  },
  key: 35
};
const stc16 = {
  classMap: {
    "slds-size_5-of-6": true
  },
  key: 38
};
const stc17 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_vertical-align-center": true
  },
  key: 39
};
const stc18 = {
  key: 40
};
const stc19 = {
  key: 41
};
const stc20 = {
  key: 44
};
const stc21 = {
  key: 45
};
const stc22 = {
  key: 48
};
const stc23 = {
  key: 49
};
const stc24 = {
  key: 52
};
const stc25 = {
  key: 53
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, c: api_custom_element, h: api_element} = $api;
  return [api_element("footer", stc0, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    style: $cmp.styles.backgroundCloud,
    attrs: {
      "title": $cmp.labelsShared.backgroundCloud
    }
  }, null)]), api_static_fragment($fragment2, 4, [api_static_part(0, {
    style: $cmp.styles.backgroundCloud,
    attrs: {
      "title": $cmp.labelsShared.backgroundCloud
    }
  }, null)]), api_static_fragment($fragment3, 6, [api_static_part(0, {
    attrs: {
      "src": $cmp.images.treesAndMountain,
      "alt": $cmp.labels.backgroundTreesAndMountain
    }
  }, null)]), api_static_fragment($fragment4, 8), api_element("div", stc1, [api_element("div", stc2, [api_static_fragment($fragment5, 12, [api_static_part(1, {
    attrs: {
      "src": $cmp.images.salesforce,
      "alt": $cmp.labelsShared.salesforceLogo
    }
  }, null)]), api_element("div", stc3, [api_element("ul", stc4, [api_element("li", stc5, [api_custom_element("page-link", _pageLink, stc6, [api_static_fragment($fragment6, 18, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.offerYourSolution
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.offerYourSolution))])])]), api_element("li", stc7, [api_custom_element("page-link", _pageLink, stc8, [api_static_fragment($fragment7, 22, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.privacyStatement
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.privacyStatement))])])]), api_element("li", stc9, [api_custom_element("page-link", _pageLink, stc10, [api_static_fragment($fragment8, 26, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.securityStatement
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.securityStatement))])])]), api_element("li", stc11, [api_custom_element("page-link", _pageLink, stc12, [api_static_fragment($fragment9, 30, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.termsOfUse
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.termsOfUse))])])]), api_element("li", stc13, [api_custom_element("page-link", _pageLink, stc14, [api_static_fragment($fragment10, 34, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.japanSite
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.japanSite))])])])])])]), api_element("div", stc15, [api_static_fragment($fragment11, 37), api_element("div", stc16, [api_element("ul", stc17, [api_element("li", stc18, [api_custom_element("page-link", _pageLink, stc19, [api_static_fragment($fragment12, 43, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.facebook
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.images.faceBook,
      "alt": $cmp.labels.facebook
    }
  }, null)])])]), api_element("li", stc20, [api_custom_element("page-link", _pageLink, stc21, [api_static_fragment($fragment13, 47, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.twitter
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.images.twitter,
      "alt": $cmp.labels.twitter
    }
  }, null)])])]), api_element("li", stc22, [api_custom_element("page-link", _pageLink, stc23, [api_static_fragment($fragment14, 51, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.linkedin
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.images.linkedIn,
      "alt": $cmp.labels.linkedin
    }
  }, null)])])]), api_element("li", stc24, [api_custom_element("page-link", _pageLink, stc25, [api_static_fragment($fragment15, 55, [api_static_part(0, {
    attrs: {
      "title": $cmp.labels.rss
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.images.rss,
      "alt": $cmp.labels.rss
    }
  }, null)])])]), api_static_fragment($fragment16, 57, [api_static_part(2, null, api_dynamic_text($cmp.labels.callUs)), api_static_part(4, null, api_dynamic_text($cmp.labels.phoneNumber))])])])]), api_static_fragment($fragment17, 59, [api_static_part(4, null, "© " + api_dynamic_text($cmp.labels.copyright))])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3untjggo4mu";
tmpl.legacyStylesheetToken = "appx-footer_footer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
